import { Component, OnInit } from '@angular/core';
import {
    UntypedFormGroup,
    UntypedFormControl,
    UntypedFormBuilder,
    AbstractControl,
} from '@angular/forms';
import { LimegearUserModel } from '../../../shared/classes/limegearUser.model';
import { UserService } from 'app/modules/shared/services/user.service';
import { ToastService } from '../../../shared/services/toast.service';
import { LimegearAuthenticationService } from '../../../login/services/limegear-authentication.service';
import { CurrentUserStateService } from '../../../shared/services/current-user-state.service';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
    passwordResetForm: UntypedFormGroup;
    loginEmail: string;
    usernameError: string;
    oldPasswordError: string;
    newPasswordError: string;
    success: boolean = false;
    loading: boolean = false;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private authenticationService: LimegearAuthenticationService,
        private currentUserStateService: CurrentUserStateService,
        private toastService: ToastService
    ) {
        this.passwordResetForm = this.createFormGroup();
    }

    ngOnInit() {
        this.setLoginEmail();
    }

    setLoginEmail() {
        this.loginEmail = this.currentUserStateService.currentUser.username;
    }

    createFormGroup() {
        return this.formBuilder.group({
            changePasswordRequest: this.formBuilder.group(
                {
                    oldPassword: new UntypedFormControl(),
                    newPassword1: new UntypedFormControl(),
                    newPassword2: new UntypedFormControl(),
                },
                { validator: [this.checkNewPasswordIsConfirmed, this.doNotAllowRecyledPassword] }
            ),
        });
    }

    checkNewPasswordIsConfirmed(group: UntypedFormGroup) {
        let newPassword = group.get('newPassword1').value;
        let confirmNewPassword = group.get('newPassword2').value;

        return newPassword === confirmNewPassword ? null : { notSame: true };
    }

    doNotAllowRecyledPassword(group: UntypedFormGroup) {
        let newPassword = group.get('oldPassword').value;
        let confirmNewPassword = group.get('newPassword1').value;

        return newPassword !== confirmNewPassword ? null : { newPasswordSameAsOld: true };
    }

    get formControl() {
        return this.passwordResetForm.get('changePasswordRequest');
    }

    get oldPassword() {
        return this.passwordResetForm.get('changePasswordRequest').get('oldPassword');
    }

    get newPassword1() {
        return this.passwordResetForm.get('changePasswordRequest').get('newPassword1');
    }

    get newPassword2() {
        return this.passwordResetForm.get('changePasswordRequest').get('newPassword2');
    }

    onSubmit() {
        this.loading = true;
        this.passwordResetForm.markAsPristine();
        this.authenticationService
            .changePassword({
                username: this.loginEmail,
                oldPassword: this.oldPassword.value,
                newPassword: this.newPassword1.value,
            })
            .subscribe((result) => {
                if (result.success) {
                    this.success = true;
                    this.usernameError = this.oldPasswordError = this.newPasswordError = '';
                    this.toastService.success('Password changed.');
                    this.loading = false;
                } else {
                    this.success = false;
                    this.loading = false;
                    switch (result.property) {
                        case 'username':
                            this.usernameError = result.errors;
                            throw new Error(this.usernameError);
                        case 'oldPassword':
                            this.oldPasswordError = result.errors;
                            this.oldPassword.setErrors({ incorrect: true });
                            this.newPassword2.markAsPristine();
                            break;
                        case 'newPassword':
                            this.newPasswordError = result.errors;
                            this.newPassword1.setErrors({ incorrect: true });
                            this.newPassword2.markAsPristine();
                            break;
                        default:
                            throw new Error('Invalid property for this error.');
                    }
                }
            });
    }

    logForm() {
        console.log(this.passwordResetForm);
    }
}
